import React, { useEffect, useState } from "react";
import { LoaderComponent } from "../../component/LoaderComponent";
import {
  agentDataSelected,
  intersubcatSelected,
} from "../../Redux/IntermediaryReducer";
import { typeOfCalculator } from "../../Redux/InsurerReducer";
import Tree from "../../assets/images/vector-smart-object-copy-7.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { typeOfCal,partnerConstant} from "../../Constant";
import { useIsMobile } from "../../Hooks/useIsMobile";
import axios from "axios";
//import { Select } from "antd";
import Select from 'react-select';


const SPLogin = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const [spData, setSpData] = useState();
  const [businesscreditchannel, setBusinesscreditchannel] = useState('');
  const isMobile = useIsMobile();
  const [refA, setRefA] = useState("");
  const [refB, setRefB] = useState("");
  const [refC, setRefC] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState();
  const [selectedEmployee, setSelectedEmployee] = useState();
  const [selectedEmployeeCode, setSelectedEmployeeCode] = useState();
  const [partnerNameErr, setPartnerNameErr] = useState(false);
  const [selectedBranchIdErr, setSelectedBranchIdErr] = useState(false);
  const [selectedEmployeeErr, setSelectedEmployeeErr] = useState(false);
  const [selectedEmployeeCodeErr, setSelectedEmployeeCodeErr] = useState(false);

  
  const getAllData = () => {
    setShowLoader(true);
        setSpData(props.paramsData.response);
        setBusinesscreditchannel(props.paramsData.businesscreditchannel);
        if(props.paramsData.businesscreditchannel === "350"){
          dispatch(
            intersubcatSelected({
              agentid: props.paramsData.agentId,
              intermedsubcatcd: props.paramsData.intermedsubcatcd,
            })
          );
        } else if (props.paramsData.response.length === 1) {
          let data = props.paramsData?.response[0];
          
          if (data["businessFor"] != 'self') {
            data["businessFor"] = "self";
            data["flowType"] = "advisor";
            data["skip"] = props.paramsData.skip;
            data["authorization"] = props.paramsData.authorization;
            data["refA"] = props.paramsData.refCodeA;
            data["refB"] = "";
            data["refC"] = "";
            data['dealerCode'] = props.paramsData.dealerCode
            data['applicationNum'] = props.paramsData.applicationNum
          }
          setRefA(props.paramsData.refCodeA);
          dispatch(agentDataSelected(data));
          dispatch(
            intersubcatSelected({
              agentid: props.paramsData.agentId,
              intermedsubcatcd: props.paramsData.intermedsubcatcd,
            })
          );
          if (props.paramsData.productName === "All Products") {
            navigate("/plan-selection");
          } else if (props.paramsData.productName === "Prohealth Prime") {
            navigate("/prohealth-prime");
            dispatch(typeOfCalculator(typeOfCal.prohealthPrime));
          } else if (props.paramsData.productName === "Lifetime Health") {
            navigate("/lifetime-health");
            dispatch(typeOfCalculator(typeOfCal.lifetime));
          } else if (props.paramsData.productName === "Prime Senior") {
            navigate("/prime-senior");
            dispatch(typeOfCalculator(typeOfCal.primeSenior));
          } else if (props.paramsData.productName === "Prohealth") {
            navigate("/prohealth-insurance");
            dispatch(typeOfCalculator(typeOfCal.prohealth));
          } else if (props.paramsData.productName === "Super Top Up") {
            navigate("/super-top-up");
            dispatch(typeOfCalculator(typeOfCal.superTopUp));
          } else if (props.paramsData.productName === "Critical Illness") {
            navigate("/critical-illness");
            dispatch(typeOfCalculator(typeOfCal.ci));
          } else if (props.paramsData.productName === "Personal Accident") {
            navigate("/personal-accident");
            dispatch(typeOfCalculator(typeOfCal.pa));
          } else if (props.paramsData.productName === "Personal Accident") {
            navigate("/personal-accident");
            dispatch(typeOfCalculator(typeOfCal.pa));
          } else if (props.paramsData.productName === "Accident Shield") {
            navigate("/accident-shield");
            dispatch(typeOfCalculator(typeOfCal.accident_Shield));
          }else if (props.paramsData.productName === "Sarvah") {
            navigate("/sarvah");
            dispatch(typeOfCalculator(typeOfCal.mchiSarvah));
          }
        } else {
          dispatch(
            intersubcatSelected({
              agentid: props.paramsData.agentId,
              intermedsubcatcd: props.paramsData.intermedsubcatcd,
            })
          );
        }
        setShowLoader(false);
      /*})
      .catch(function (error) {
        console.log(error);
      });*/
  };
  
  useEffect(() => {
    getAllData();
  }, []);

  useEffect(() => {
    //data pre pop for bluechip case 
    if(spData && spData[0].parentagencyid == partnerConstant.BLUECHIP_PARENT_AGENT_ID){
        setPartnerName(spData[0].parentagencyname);
        //console.log(spData);        
        if(spData.length ==1){
          setSelectedBranchId(spData[0].branchId);
          setSelectedEmployee(spData[0].employeeNameOrSPName);
          setSelectedEmployeeCode(spData[0].agentId);
          setRefA(props.paramsData?.refCodeA);
          setRefB(props.paramsData?.refCodeB);
          setRefC(props.paramsData?.refCodeC);
        }
        //console.log(spData)  
        /*if(arrayOfBranch.length > 0 && arrayOfBranch[0]){
          handleSelectedBrandId(arrayOfBranch[0]);
        }*/
    } 
  }, [spData]);

  const checkValidFields = () => {
    let errors = {};
    if (!partnerName) {
      setPartnerNameErr(true);
      errors["partnerName"] = true;
    }
    if (!selectedBranchId) {
      setSelectedBranchIdErr(true);
      errors["selectedBranchId"] = true;
    }
    if (!selectedEmployee) {
      setSelectedEmployeeErr(true);
      errors["selectedEmployee"] = true;
    }
    if (!selectedEmployeeCode) {
      setSelectedEmployeeCodeErr(true);
      errors["selectedEmployeeCode"] = true;
    }
    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }
  };
  const onNextClick = () => {
    if (checkValidFields()) {
      return;
    }
    let data = spData.find(
      (employeeData) => employeeData.employeeNameOrSPName == selectedEmployee && employeeData.branchId === selectedBranchId
    );
    if (data) {
      data["businessFor"] = "partner";
      data["flowType"] = "advisor";
      data["skip"] = props.paramsData.skip;
      data["authorization"] = props.paramsData.authorization;
      data["refA"] = refA;
      data["refB"] = refB;
      data["refC"] = refC;
    }
    dispatch(agentDataSelected(data));
    if (props.paramsData.productName === "All Products") {
      navigate("/plan-selection");
    } else if (props.paramsData.productName === "Prohealth Prime") {
      navigate("/prohealth-prime");
      dispatch(typeOfCalculator(typeOfCal.prohealthPrime));
    } else if (props.paramsData.productName === "Lifetime Health") {
      navigate("/lifetime-health");
      dispatch(typeOfCalculator(typeOfCal.lifetime));
    } else if (props.paramsData.productName === "Prime Senior") {
      navigate("/prime-senior");
      dispatch(typeOfCalculator(typeOfCal.primeSenior));
    } else if (props.paramsData.productName === "Prohealth") {
      navigate("/prohealth-insurance");
      dispatch(typeOfCalculator(typeOfCal.prohealth));
    } else if (props.paramsData.productName === "Super Top Up") {
      navigate("/super-top-up");
      dispatch(typeOfCalculator(typeOfCal.superTopUp));
    } else if (props.paramsData.productName === "Personal Accident") {
      navigate("/personal-accident");
      dispatch(typeOfCalculator(typeOfCal.pa));
    } else if (props.paramsData.productName === "Critical Illness") {
      navigate("/critical-illness");
      dispatch(typeOfCalculator(typeOfCal.ci));
    } else if (props.paramsData.productName === "Personal Accident") {
      navigate("/personal-accident");
      dispatch(typeOfCalculator(typeOfCal.pa));
    } else if (props.paramsData.productName === "Accident Shield") {
      navigate("/accident-shield");
      dispatch(typeOfCalculator(typeOfCal.accident_Shield));
    }else if (props.paramsData.productName === "Sarvah") {
      navigate("/sarvah");
      dispatch(typeOfCalculator(typeOfCal.mchiSarvah));
    }
  };

  const uniqueBranchIds = spData &&
    spData.length > 0 && [
      ...new Map(spData.map((m) => [m.branchId, m])).values(),
    ];

  const arrayBranchIds =
    uniqueBranchIds &&
    uniqueBranchIds.length > 0 &&
    uniqueBranchIds.map((src, index) => {
      return (
        <option key={index} value={src.branchId}>
          {src.branchId}
        </option>
      );
    });

    const arrayOfBranch = uniqueBranchIds &&
    uniqueBranchIds.length > 0 &&
    uniqueBranchIds.map((item)=> {
      return(
        {'label': item.branchId , 'value': item.branchId}
      )
    })

  const arrayFilteredEmployeeDetails =
    spData &&
    spData.length > 0 &&
    spData.filter((spData) => spData.branchId == selectedBranchId);


  const arrayEmployeeDMSNames =
    arrayFilteredEmployeeDetails &&
    arrayFilteredEmployeeDetails.length > 0 &&
    arrayFilteredEmployeeDetails.map((src, index) => {
      return (
        <option key={index} value={src.employeeNameOrSPName}>
          {src.employeeNameOrSPName}
        </option>
      );
    });

  const arrayEmployeeDMSCodes =
    spData &&
    spData.length > 0 &&
    spData.find((spData) => spData.employeeNameOrSPName == selectedEmployee);

  const handleSelectedBrandId = (value) => {
    setSelectedBranchId(value);
    setSelectedEmployee("");
    setSelectedEmployeeCode("");
  };

  const handleSelectedEmployee = (value) => {
    setSelectedEmployee(value);
  };
  const handleSelectedEmployeeCode = (value) => {
    setSelectedEmployeeCode(value);
  };


  return (
    <>
      {showLoader && <LoaderComponent />}
      {(businesscreditchannel === '350' || (businesscreditchannel !== '350' && spData?.length > 1)) && (
        <div className="App">
          <div className="bg_blue mt-5">
            <div className="row mt-5">
              <div
                className={
                  isMobile ? "col-md-12 p-0 text-center" : "col-md-12 p-0"
                }
              >
                <div
                  className={isMobile ? "jumbotron" : "jumbotron pt-3 p-4 mt-5"}
                  style={{ marginTop: `${isMobile ? "80px" : "0px"}` }}
                >
                  <h3 className="text-white">
                    Welcome{" "}
                    {props.paramsData.intermedsubcatcd === "SP"
                      ? spData && spData[0]?.agentName
                      : spData && spData[0].employeeNameOrSPName}
                  </h3>
                  <p className="text-white">
                    DMS Code -{" "}
                    {props.paramsData.intermedsubcatcd === "SP"
                      ? spData && spData[0].agentId
                      : spData && spData[0].employeeCodeOrSPCode}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg_light_blue mt-4">
            <div className="container mt-5">
              <div className="row" style={{ marginTop: "-100px" }}>
                <div>
                  <div className="card p-4">
                    <div className="container" style={{ display: "grid" }}>
                      <div className="row">
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Partner Name</b>
                              <i className="red">*</i>
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={partnerName}
                              onChange={(e) => setPartnerName(e.target.value)}
                            >
                              <option selected hidden>
                                Select
                              </option>
                              {/* {arrayPartnerNames} */}
                              <option>
                                {spData && spData[0].parentagencyname}
                              </option>
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!partnerName &&
                              partnerNameErr &&
                              "Please enter Partner Name"}
                          </div>
                        </div>
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Partner Branch Code</b>
                              <i className="red">*</i>
                            </label>
                            {spData.length > 1 && ( 
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={arrayOfBranch}
                                onChange={(src)=>handleSelectedBrandId(src?.value)}
                              />
                            )}
                             {spData.length == 1 && ( 
                              <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={arrayOfBranch}
                                onChange={(src)=>handleSelectedBrandId(src?.value)}
                                defaultValue ={arrayOfBranch.length ==1  && arrayOfBranch[0]}
                              />
                            )}
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedBranchId &&
                              selectedBranchIdErr &&
                              "Please enter Branch Code"}
                          </div>
                        </div>
                        <div className="col-md-4"></div>
                      </div>

                      <div className="row">
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Name</b>
                              <i className="red">*</i>
                            </label>                            
                            {spData.length > 1 && ( 
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployee(e.target.value)
                              }
                              value={selectedEmployee}
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {arrayEmployeeDMSNames}
                            </select>
                          )}

                          {spData.length == 1 && ( 
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployee(e.target.value)
                              }
                              value={selectedEmployee}
                            >
                              <option>
                                {spData[0].employeeNameOrSPName}
                              </option>                              
                            </select>
                          )}  
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployee &&
                              selectedEmployeeErr &&
                              "Please enter Employee Name"}
                          </div>
                        </div>
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>Code</b>
                              <i className="red">*</i>
                            </label>
                            {spData.length > 1 && (
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                onChange={(e) =>
                                  handleSelectedEmployeeCode(e.target.value)
                                }
                                value={selectedEmployeeCode}
                              >
                                <option>
                                    {spData[0].agentName}
                                </option>
                              </select>
                            )}
                            {spData.length == 1 && (
                              <select
                                className="form-select"
                                aria-label="Default select example"
                                onChange={(e) =>
                                  handleSelectedEmployeeCode(e.target.value)
                                }
                                value={selectedEmployeeCode}>
                                <option>
                                  {spData[0].agentId}
                                </option>
                              </select>
                            )}
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployeeCode &&
                              selectedEmployeeCodeErr &&
                              "Please enter Employee Code"}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              <b>MCHI Branch Code</b>
                              <i className="red">*</i>
                            </label>
                            <input
                              className="form-control disabled-input text-center"
                              type="text"
                              value={spData.length==1?spData[0].mappedirdalocation:arrayEmployeeDMSCodes && arrayEmployeeDMSCodes.mappedirdalocation}
                              aria-label="Disabled input example"
                              disabled
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref A(Unique Reference Number)</b>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refA}
                            onChange={(e) => setRefA(e.target.value)}
                            readOnly
                          ></textarea>
                        </div>
                        <div className="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref B</b>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refB}
                            onChange={(e) => setRefB(e.target.value)}
                          ></textarea>
                        </div>
                        <div className="col-md-4 p-3">
                          <label className="mb-1">
                            <b>Ref C</b>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Give description here"
                            id="floatingTextarea"
                            value={refC}
                            onChange={(e) => setRefC(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ background: "#f5f5f5" }}>
            <div className="fixed mt-3">
              <div className="row">
                <div className="col-6">
                  <img
                    src={Tree}
                    alt="vector-smart-object-copy-7"
                    className="tree-image"
                  />
                </div>
                <div className="col-6 text-right" style={{ top: "45px" }}>
                  <button
                    onClick={() => onNextClick()}
                    className="btn btn-primary-custom"
                  >
                    NEXT &nbsp;
                    <i className="fa fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SPLogin;